import React, { Component } from 'react';
import './index.scss';
import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Redirect } from 'react-router-dom';
import { Dialog, DialogType, DialogFooter } from '@fluentui/react/lib/Dialog';
import { Spinner, SpinnerSize, TextField } from '@fluentui/react';
import { getUserValidateApi } from '../../api/user';
import { IStore } from '../../schemas';
import {
	openLoadingDialog
} from '../../redux/actions';
import { connect } from 'react-redux';
interface ILoginState {
	logined?: boolean;
	loading?: boolean;

}

interface ILoginProps {
	currentUser: any
	openLoadingDialog: (data) => void;
	common?: any;
}

class LoginAuth extends Component<ILoginProps, ILoginState> {
	private _token = '';
	public state: ILoginState = {
		logined: false,
	};
	componentDidMount() {
		const tokenCode = sessionStorage.getItem('teamsAuthToken');
		if (tokenCode) {
			this.setState({ logined: true })
		}
	}

	getAuthCode = async () => {
		let ssoConfig;
		ssoConfig = await import('../../ssoConfig.json');
		console.log(ssoConfig);
		this.props.openLoadingDialog({ loadingOpen: true })
		window.location.assign(`https://login.microsoftonline.com/3ac94b33-9135-4821-9502-eafda6592a35/oauth2/v2.0/authorize?client_id=${ssoConfig.client_id}&response_type=${ssoConfig.response_type}&response_mode=${ssoConfig.response_mode}&redirect_uri=${ssoConfig.redirect_uri}&scope=${ssoConfig.scope}`)
	}

	render() {
		let html: any = null;
		if (this.state.logined) {
			html = <Redirect to='/portal' />
		} else {
			html = <div className='loginAuth' >
				<img src="/bg.png" style={{ marginTop: '100px', marginBottom: '20px', height: '400px' }}></img>
				<PrimaryButton
					text='Click to Authentication'
					disabled={false}
					onClick={async () => {
						await this.getAuthCode();
					}}
				/>

			</div>
		}
		return (
			<>
				<div>{html}</div>
				{this.props.common.loadingOpen ? (
					<div
						style={{
							position: 'absolute',
							width: '100%',
							height: '100%',
							top: 0,
							left: 0,
							backgroundColor: 'rgba(0, 0, 0, 0.6)',
							zIndex: 1,
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
						}}
					>
						<Spinner
							size={SpinnerSize.large}
							label='Authorization...'
							styles={{
								label: {
									color: 'white',
									fontSize: '1rem',
									fontWeight: 'bold',
								},
							}}
						/>
					</div>
				) : null}
			</>
		);
	}
}

export default connect(
	(state: IStore) => ({
		currentUser: state.currentUser,
		common: state.common
	}),
	{
		openLoadingDialog
	}
)(LoginAuth);
